import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as subscriptionActions from '../../actions/subscriptionActions';
import {EMAIL_REGEX} from '../../constants/formats';
import Modal from 'react-modal';
import TextField from '../common/TextField/TextField';
import './SubscribePromo.less';

class SubscribePromo extends React.Component {
  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.state = {
      email: '',
      validationRun: 0,
      valid: true
    };
  }

  validate() {
    const email = (this.state.email || '').trim();
    const valid = EMAIL_REGEX.test(email);
    const validationRun = valid ? 0 : this.state.validationRun + 1;

    this.setState({validationRun, valid});
    return valid;
  }

  closeModal() {
    this.props.subscriptionActions.hideModal();
  }

  handleEmailChange(email) {
    this.setState({email});
  }

  handleFormSubmit(ev) {
    ev.preventDefault();

    const {isSubscribed} = this.props;
    if (isSubscribed) {
      this.closeModal();
      return;
    }

    if (this.validate()) {
      const email = this.state.email;
      const {subscriptionActions} = this.props;

      subscriptionActions.subscribe(email);
    }
  }

  render () {
    const {handleFormSubmit, closeModal, handleEmailChange} = this;
    const {email, valid, validationRun} = this.state;
    const {isOpen, isSubscribed} = this.props;

    return (
      <Modal contentLabel="Subscribe"
        className="modal subscribe-promo"
        overlayClassName="modal-overlay"
        isOpen={isOpen}
        shouldCloseOnOverlayClick={true}
        onRequestClose={closeModal}
        closeTimeoutMS={100}>
        <heading>
          <h1>Wcrótce otwarcie!</h1>
          <small className="close-button" onClick={closeModal}/>
          <div className="discount">
            <strong>50%</strong>
          </div>
          {!isSubscribed && <div>
            <p>Bądż z Nami a skorzystasz z 50% rabatu na pierwsze zamówienie.</p>
            <p>Zarejestruj się już dziś!</p>
            </div>
          }
        </heading>
        <form action="" onSubmit={handleFormSubmit}>
          {isSubscribed ? (<div>
              <p>Dziękujemy!</p>
              <p>Wyślemy kod promocyjny na podany email w dniu otwarcia.</p>
            </div>) :
            <TextField type="email" value={email} placeholder="Twój e-mail" onChange={handleEmailChange} validationRun={validationRun} valid={valid}/>
          }
          <input type="submit" value={isSubscribed ? 'OK' : 'Wyślij'} className="btn btn-primary btn-block"/>
        </form>
      </Modal>
    );
  }
}

SubscribePromo.propTypes = {
  isOpen: PropTypes.bool,
  isSubscribed: PropTypes.bool,
  subscriptionActions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    isOpen: state.subscription.isModalOpen,
    isSubscribed: state.subscription.isSubscribed
  };
}

function mapDispatchToProps(dispatch) {
  return {
    subscriptionActions: bindActionCreators(subscriptionActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubscribePromo);



// WEBPACK FOOTER //
// ./src/components/SubscribePromo/SubscribePromo.js